import { render } from "./Ad-Be.vue?vue&type=template&id=3327c2db&scoped=true&lang=pug"
import script from "./Ad-Be.vue?vue&type=script&lang=js"
export * from "./Ad-Be.vue?vue&type=script&lang=js"

import "./Ad-Be.vue?vue&type=style&index=0&id=3327c2db&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3327c2db"]])

export default __exports__